import React, {Component} from 'react';
import {connect} from 'react-redux';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import {filterGraph} from './riFilters';

function relTypeLabel(relType) {
  if (relType === 'VIEW_DEP') return 'VIEW DEP';
  if (relType === 'CIRCULAR') return 'CIRCULAR';
  return 'FK 1:N';
}

function relTypeBadgeClass(relType) {
  if (relType === 'VIEW_DEP') return 'ri-type-badge ri-badge-view';
  if (relType === 'CIRCULAR') return 'ri-type-badge ri-badge-circular';
  return 'ri-type-badge ri-badge-fk';
}

class RiTableView extends Component {
  getFilteredEdges() {
    const {graph, filters, search} = this.props;
    return filterGraph(graph, filters, search).edges;
  }

  render() {
    const edges = this.getFilteredEdges();

    return (
      <div className="ri-table-wrap" data-testid="ri-table">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Direction</TableCell>
              <TableCell>Parent (referenced)</TableCell>
              <TableCell></TableCell>
              <TableCell>Child (referencing)</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Constraint</TableCell>
              <TableCell>Cascade</TableCell>
              <TableCell>Cross-schema</TableCell>
              <TableCell>FK Index</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {edges.length === 0 && (
              <TableRow>
                <TableCell colSpan={9} align="center" style={{color: '#606060', fontStyle: 'italic'}}>
                  No relationships found.
                </TableCell>
              </TableRow>
            )}
            {edges.map((edge, i) => {
              const parentCol = edge.parentColumnName ? `.${edge.parentColumnName}` : '';
              const childCol = edge.childColumnName ? `.${edge.childColumnName}` : '';
              const dir = edge.isUpstream ? 'Upstream' : edge.isDownstream ? 'Downstream' : '—';
              const fkIndex = edge.fkIndexPresent === true ? 'Yes' :
                edge.fkIndexPresent === false ? 'No' : 'Unknown';

              return (
                <TableRow key={edge.edgeId || i} data-testid="ri-row">
                  <TableCell>{dir}</TableCell>
                  <TableCell>{(edge.parentObjectName || '') + parentCol}</TableCell>
                  <TableCell className="ri-arrow">→</TableCell>
                  <TableCell>{(edge.childObjectName || '') + childCol}</TableCell>
                  <TableCell>
                    <span className={relTypeBadgeClass(edge.relType)}>
                      {relTypeLabel(edge.relType)}
                    </span>
                  </TableCell>
                  <TableCell>{edge.constraintName || '—'}</TableCell>
                  <TableCell>{edge.cascadeDelete || '—'}</TableCell>
                  <TableCell>
                    {edge.crossSchema ? <span className="ri-cross-schema-flag">Yes</span> : 'No'}
                  </TableCell>
                  <TableCell>{fkIndex}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  graph: state.dependencyAnalysis.graph,
});

export default connect(mapStateToProps)(RiTableView);
